module.exports = __webpack_public_path__ + "img/password.5826a703.svg";